import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["NotFound"] */ "/app/src/components/new/NotFound/NotFound.tsx");
